<template>
  <div
    v-if="jobId"
    class="w-3/4"
  >
    <h3 class="text-dark flex justify-between">
      <span>Job Status for ID: {{ jobId }}</span>
      <form
        v-if="job.status === 'Completed'"
      >
        <XnInput
          v-model="job.add_to_order"
          :disabled="job.status != 'Completed'"
          type="checkbox"
          label="Add To Order"
        />
      </form>
    </h3>
    <xn-progress
      class="h-6 mx-2 mb-2"
      :percentage="jobPercent"
    >
      <span class="text-xs text-white w-full flex justify-end pr-2">{{
        jobStatus
      }}</span>
    </xn-progress>
    <div class="flex flex-row items-center justify-around ">
      <h3
        v-if="price && jobStatus!='Analyzed'"
        class="text-dark"
      >
        Estimated Price:
        {{
          toCurrency(price)
        }}
      </h3>
    </div>
  </div>
</template>
<script>
import GeneralMixins from '../mixins/GeneralMixins.vue'
import XnProgress from './primitives/XnProgress.vue'
import XnInput from './primitives/XnInput.vue'
export default {
  name: 'JobUpdates',
  components: { XnProgress, XnInput },
  mixins:[GeneralMixins],
  props: {
    price: { type: Number, default: null },
    jobStatus: { type: String, default: null },
    jobId: { type: String, default: null },
    job: { type: Object, default: () => {} }
  },
  data () {
    return {}
  },
  computed: {
    jobPercent () {
      switch (this.jobStatus) {
        case null:
          return 0
        case 'Created':
        case 'Sent':
          return 20
        case 'Processing':
          return 50
        case 'Analyzed':
          return 80
        case 'Errored':
        case 'Completed':
        case 'Requested':
        case 'Approved':
        case 'Ordered':
        case 'Expired':
          return 100
        default:
          return 50
      }
    },
  },
}
</script>
<style lang="postcss" scoped></style>
